module.exports = __webpack_public_path__ + "img/semi_parked.e81b9cbd.svg";